"use client";

import { useI18n } from "@/context/i18-provider";
import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { TLocale } from "@/i18n/config";
import { langItems } from "@/utils/constants";
import { RenderDefaultLang, RenderLang } from "@/utils/render";
import { SelectGroup } from "@radix-ui/react-select";

const Lang = () => {
  const { changeLanguage, locale } = useI18n();

  return (
    <div>
      <Select defaultValue={locale} onValueChange={changeLanguage}>
        <SelectTrigger className="w-36 cursor-pointer rounded-2xl border border-gray-300 focus-within:outline-none focus:ring-0">
          <SelectValue
            placeholder={RenderDefaultLang(locale as TLocale)}
            defaultValue={locale}
          />
        </SelectTrigger>
        <SelectContent className="rounded-2xl relative z-[1000] border border-gray-300">
          <SelectGroup>{langItems.map(RenderLang)}</SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};

export default Lang;
